/////////////////////////////////////////////
// DEFAULT PROPS FOR COMPONENTS
/////////////////////////////////////////////

export const FONT_FAMILY = {
  heading: `'Monsieur La Doulaise', cursive;`,
  subHeading: `'Nanum Myeongjo', serif;`,
  body: `'Baskervville', serif;`,
  body_lv2: `'Nanum Myeongjo', serif;`,
};

export const TEXT_PROPS = {
  heading: {
    fontFamily: 'heading',
    fontSize: 'heading',
    fontWeight: 'heading',
    fontStyle: 'var(--fontItalic-heading)',
    textAlign: 'center',
    lineHeight: '1.2',
  },
  subHeading: {
    fontFamily: 'subHeading',
    fontSize: 'subHeading',
    fontWeight: 'subHeading',
    fontStyle: 'var(--fontItalic-subHeading)',
    textAlign: 'center',
  },
  body: {
    fontFamily: 'body',
    fontSize: 'body',
    fontWeight: 'body',
    fontStyle: 'var(--fontItalic-body)',
  },
  body_lv2: {
    fontFamily: 'body_lv2',
    fontSize: 'body_lv2',
    fontWeight: 'body_lv2',
    fontStyle: 'var(--fontItalic-body_lv2)',
  },
};

export const DEFAULT_PROPS = {
  button_transparent: {
    _active: { borderColor: 'transparent' },
    _hover: { borderColor: 'transparent' },
    _focus: { borderColor: 'transparent' },
  },
  button: {
    fontWeight: 'normal',
    borderBottom: '1.5px solid',
    borderColor: 'mainColorText',
    bgColor: 'transparent',
    color: 'mainColorText',
    fontFamily: 'body',
    fontSize: 'body',
    borderRadius: 'none',
    padding: '4px 4px 8px',
    height: 'unset',
    size: 'md',
    _active: { bgColor: 'blackAlpha.100' },
    _hover: { bgColor: 'blackAlpha.100' },
    _focus: { bgColor: 'blackAlpha.100' },
  },
};
